import { makeAutoObservable } from "mobx";
import { UsersContext } from "../../typings/context";
import { SupervisorProfileInfo } from "../../../api/typings/Profiles";

export class ProfileSupervisorService {
  constructor(private ctx: UsersContext) {
    this.ctx = ctx;
    makeAutoObservable(this);
  }

  updateProfile = (data: SupervisorProfileInfo) => {};
}
